import { render, staticRenderFns } from "./CancelFlowBtn.vue?vue&type=template&id=bbf54316"
import script from "./CancelFlowBtn.vue?vue&type=script&lang=js"
export * from "./CancelFlowBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports